<template>
    <nav id="reservations_steps_nav" class="reservations_steps_nav" ref="stepsNav">
        <ul>

            <li :class="liClass(item)" v-for="(item,index) in list">

                <router-link v-if="isLink(item)"
                             :to="{name: item.to}"
                             data-type="step"
                             :data-step="index"
                             :title="item.title">
                    {{ index + 1 }}. {{ item.title }}
                </router-link>

                <span v-else> {{ index + 1 }}. {{ item.title }}</span>


            </li>

        </ul>
    </nav>
</template>

<script>
export default {
    name : "Navigation"
}
</script>

<script setup>

import {onMounted, ref} from "vue";
import {useMainStore} from "../stores/main";
import {storeToRefs} from "pinia";

let props = defineProps( [ "selected" ] );

let store              = useMainStore();
let { copydeck, lang } = storeToRefs( store );

let currScroll = ref( 0 );
let stepsNav   = ref( null );

let list = ref(
    [
        {
            to            : 'Order',
            title         : copydeck.value.breadcrumbs.order[ lang.value ],
            key           : 'order',
            completedWhen : [ 'recap', 'coords', 'confirmation' ],
            linkWhen      : [ 'recap', 'coords' ]
        },

        {
            to            : 'Recap',
            title         : copydeck.value.breadcrumbs.recap[ lang.value ],
            key           : 'recap',
            completedWhen : [ 'coords', 'confirmation' ],
            linkWhen      : [ 'coords' ]
        },

        {
            to            : 'Coords',
            title         : copydeck.value.breadcrumbs.coords[ lang.value ],
            key           : 'coords',
            completedWhen : [ 'confirmation' ],
            linkWhen      : []
        },

        {
            to            : 'Confirmation',
            title         : copydeck.value.breadcrumbs.confirmation[ lang.value ],
            key           : 'confirmation',
            completedWhen : [],
            linkWhen      : []

        }
    ]
)

function liClass( item ) {
    if ( item.key === props.selected ) {
        return "active";
    }

    if ( item.completedWhen.includes( props.selected ) ) {
        return "completed";
    }
}

function isLink( item ) {
    return item.linkWhen.includes( props.selected );
}

onMounted( () => {


    // window.addEventListener( 'message', ( e ) => {
    //
    //
    //     if ( e?.data?.source ?? '' === 'vue-devtools-backend-injection' ) {
    //         return;
    //     }
    //
    //
    //     const data = e.data;
    //
    //     if ( ( data?.type ?? '' === 'scroll' ) && ( data?.y ?? -1 > -1 ) ) {
    //         let wantedY = data.y;
    //
    //         // often getting values between 1 and 10 and sometimes more when
    //         // near the top of the page... making it a little magnetic
    //         if ( wantedY < 12 ) {
    //             wantedY = 0;
    //         }
    //
    //         if ( stepsNav.value ) {
    //             currScroll.value         = wantedY;
    //             stepsNav.value.style.top = wantedY + 'px';
    //             // console.log( '%c 🔨 Child: Sticking the "sticky" nav to ' + wantedY + 'px', 'background: yellow; font-weight: bold; color: black;' )
    //         }
    //     }
    //
    // } );

} )
</script>
